import React from 'react';
import cn from 'bem-cn';

import { Icon, Stack, Link } from '../../../components/UI';
import { Feed } from '../../../components/Feed';
import { usePromptFeedColumns } from '../../HomePage/HomePage.hooks';
import { NewPromptBanner } from '../../../components/NewPromptBanner';
import { useInfiniteScroll } from '../../../hooks/useInfiniteScroll';
import { useMyPromptsFeed } from './useMyPromptsFeed';

import './MyProfilePrompts.scss';

const b = cn('my-profile-prompts');

export const MyProfilePrompts: React.FC = () => {
    const { prompts: myPrompts, loading: isLoading, hasMore, loadMore } = useMyPromptsFeed(20);

    // Настройка infinite scroll
    useInfiniteScroll(loadMore, {
        threshold: 600,
        enabled: true,
        hasMore,
        loading: isLoading,
    });

    const columns = usePromptFeedColumns();
    // Ограничиваем колонки до 4 (так как ширина контейнера ограничена 1306px)
    const correctedColumns = Math.min(4, columns, Math.max(2, myPrompts.length));

    const getSectionSize = () => {
        if (myPrompts.length < 3) {
            return 'small';
        }

        if (myPrompts.length === 3) {
            return 'medium';
        }

        return 'large';
    };

    return (
        <Stack spacing={24} className={b({ size: getSectionSize() })}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" className={b('header')}>
                <h2>Мои промпты</h2>
                {myPrompts.length > 1 && (
                    <Link to="/new" className="new-prompt-button">
                        <p>Новый промпт</p>
                        <Icon name="plus" size={24} fillColor="var(--accent-color)" />
                    </Link>
                )}
            </Stack>

            {!isLoading && myPrompts.length === 0 ? (
                <NewPromptBanner />
            ) : (
                <Feed
                    containerClassName={b('feed')}
                    prompts={myPrompts}
                    columns={correctedColumns}
                    isLoading={isLoading}
                    hasMore={hasMore}
                    showStatuses
                    showNewPromptCard={myPrompts.length === 1}
                />
            )}
        </Stack>
    );
};
